import { urlQueryStringToObj } from './urlQueryStringToObj';
import { objToStr } from './objToStr';

export const setAssetParams = (assetMediaArray, isTest, type) => {
  const videoSrcs = assetMediaArray.video && assetMediaArray.video.srcs;
  const imageSrcs = assetMediaArray.image && assetMediaArray.image.srcSet;

  if (isTest) return `${assetMediaArray.imageEnabled ? 'Image' : 'Video'} asset`;

  if (type === 'video') {
    const objKeys = Object.keys(videoSrcs);

    objKeys.forEach((key) => {
      if (videoSrcs[`${key}`].poster !== '' && videoSrcs[`${key}`].poster.includes('jpg')) {
        const [slideImageSrc, slideImageSrcQueryParams] = videoSrcs[`${key}`].poster.split('?');

        const slideImageSrcQueryParamsObj = urlQueryStringToObj(slideImageSrcQueryParams);

        slideImageSrcQueryParamsObj.preferwebp = 'true';

        const src = `${slideImageSrc}?${objToStr(slideImageSrcQueryParamsObj)}`;
        videoSrcs[`${key}`].poster = src;
      }
    });
  }

  if (type === 'image') {
    imageSrcs.forEach((imgObj) => {
      if (imgObj.src) {
        const [slideImageSrc, slideImageSrcQueryParams] = imgObj.src.split('?');
        const slideImageSrcQueryParamsObj = urlQueryStringToObj(slideImageSrcQueryParams);
        slideImageSrcQueryParamsObj.preferwebp = 'true';
        // slideImageSrcQueryParamsObj.width = '915';
        const src = `${slideImageSrc}?${objToStr(slideImageSrcQueryParamsObj)}`;
        imgObj.src = src;
      }
    });
  }

  return {
    ...assetMediaArray,
    video: { ...assetMediaArray.video, srcs: videoSrcs },
    image: { ...assetMediaArray.image, srcSet: imageSrcs },
  };
};
